import {
    Button,
    Dialog,
    DialogActions,
    DialogBody,
    DialogSurface,
    DialogTitle,
    DialogTrigger,
    makeStyles,
    mergeClasses,
    shorthands,
    DialogContent,
} from '@fluentui/react-components';
import { Dismiss20Filled } from '@fluentui/react-icons';
import { AlwaysOnScrollBarStyles, Breakpoints, customColors } from '../../../styles';
import { NexusAgent } from '../../../domain/agents/models/Agent';
import AgentOverviewContent from './partials/AgentOverviewContent';
import AgentOverviewHeader from './partials/AgentOverviewHeader';

const useStyles = makeStyles({
    dialogSurface: {
        left: '20%',
        maxWidth: '75%',
        height: '80%',
        paddingTop: '0',
        backgroundColor: customColors.protivitiOffWhite,
        overflowY: 'auto',
        ...AlwaysOnScrollBarStyles,

        '@media (max-width: 1000px)': {
            left: '5rem',
            width: '90%',
        },
    },

    dialogActions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        zIndex: 1,
        position: 'sticky',
        top: '0',
        width: '100%',
        padding: '24px 24px 8px 24px',
        marginBottom: '0',
        backgroundColor: customColors.protivitiOffWhite,
    },
    button: {
        borderRadius: '5px',
        padding: '8px 18px',
        ...shorthands.borderColor(customColors.protivitiOrange),
    },
    startChatButton: {
        color: customColors.white,
        backgroundColor: customColors.protivitiOrange,
        fontSize: '12pt',

        '&:hover': {
            color: customColors.white,
            backgroundColor: customColors.protivitiDarkBlue,
        },
    },
    closeButton: {
        marginBottom: '50px',
        backgroundColor: 'transparent', // Ensure no background color on hover
        border: 'none', // Remove border
        ...Breakpoints.small({
            maxWidth: '24px',
            maxHeight: '24px',
        }),
        '&:hover': {
            backgroundColor: 'transparent', // Disable hover background color
            color: 'inherit', // Prevent color change on hover
        },
        '&:focus': {
            outline: 'none', // Remove focus outline
            backgroundColor: 'transparent', // Ensure no background color on focus
        },
    },

    dialogBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: '25px',
        padding: '0',
        overflow: 'unset',
        maxHeight: 'unset',
    },
    dialogContent: {
        display: 'flex',
        justifyContent: 'center',
        paddingBottom: '50px',
    },
});

interface AgentOverviewDialogProps {
    agent: NexusAgent | null;
    setIsDialogOpen: (agent: NexusAgent | null) => void;
}

const AgentOverviewDialog: React.FC<AgentOverviewDialogProps> = ({ agent, setIsDialogOpen }) => {
    const styles = useStyles();

    return (
        <Dialog open={agent !== null} onOpenChange={(_event, data) => !data.open && setIsDialogOpen(null)}>
            <DialogSurface className={styles.dialogSurface}>
                <DialogActions className={styles.dialogActions}>
                    <DialogTrigger>
                        <Button
                            // onClick={createChat}
                            // style={{
                            //     cursor: isCreatingChat ? 'progress' : 'pointer',
                            //     opacity: isCreatingChat ? 0.5 : 1,
                            //     pointerEvents: isCreatingChat ? 'none' : 'auto',
                            //     borderColor: customColors.protivitiOrange,
                            // }}
                            className={mergeClasses(styles.button, styles.startChatButton)}
                        >
                            Start a chat
                        </Button>
                    </DialogTrigger>
                    <DialogTrigger action="close">
                        <Button
                            onClick={() => setIsDialogOpen(null)}
                            className={styles.closeButton}
                            icon={<Dismiss20Filled />}
                        />
                    </DialogTrigger>
                </DialogActions>

                <DialogBody className={styles.dialogBody}>
                    <DialogTitle>
                        <AgentOverviewHeader agent={agent} />
                    </DialogTitle>
                    <DialogContent className={styles.dialogContent}>
                        <AgentOverviewContent agent={agent} />
                    </DialogContent>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export default AgentOverviewDialog;
